module.exports = __webpack_public_path__ + "static/media/img2.3a5f3441.png";